import { eTipoPermissao } from '@/enums/ePermissoes';
export interface RelatorioAtendimentoOpcao {
  id: string;
  texto: string;
  permissao: eTipoPermissao;
  complementar?: eTipoPermissao;
  periodo: string;
}
export const relatoriosAtendimento: RelatorioAtendimentoOpcao[] = [
  {
    id: 'AnalisesAnalitico',
    texto: 'Analítico — Solicitações e análises',
    permissao: eTipoPermissao.ATENDIMENTO_REL_ANALISESANALITICO_NOVO_MENU_3200106101,
    periodo: 'Data da solicitação',
  },
  {
    id: 'Analises',
    texto: 'Sintético — Solicitações por situação e especialidade',
    permissao: eTipoPermissao.ATENDIMENTO_REL_ANALISES_NOVO_MENU_3200106102,
    periodo: 'Data da solicitação',
  },
  {
    id: 'Pendentes',
    texto: 'Analítico — Solicitações pendentes de avaliação',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PENDENTES_NOVO_MENU_3200106103,
    periodo: 'Data da solicitação; apenas pendentes',
  },
  {
    id: 'PendentesSintetico',
    texto: 'Sintético — Solicitações pendentes de avaliação',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PENDENTESSINTETICO_NOVO_MENU_3200106104,
    periodo: 'Data da solicitação; dias de espera médios',
  },
  {
    id: 'MovimentacoesAnalitico',
    texto: 'Analítico — Ingressos e desligamentos',
    permissao: eTipoPermissao.ATENDIMENTO_REL_MOVIMENTACOESANALITICO_NOVO_MENU_3200106105,
    periodo: 'Data do ingresso ou desligamento',
  },
  {
    id: 'Movimentacoes',
    texto: 'Sintético — Ingressos e desligamentos',
    permissao: eTipoPermissao.ATENDIMENTO_REL_MOVIMENTACOES_NOVO_MENU_3200106106,
    periodo: 'Data do ingresso ou desligamento',
  },
  {
    id: 'ServicosAnalitico',
    texto: 'Analítico — Serviços de atendimento',
    permissao: eTipoPermissao.ATENDIMENTO_REL_SERVICOSANALITICO_NOVO_MENU_3200106107,
    periodo: 'Serviços vigentes em algum momento do período',
  },
  {
    id: 'ServicosSintetico',
    texto: 'Sintético — Serviços de atendimento',
    permissao: eTipoPermissao.ATENDIMENTO_REL_SERVICOSSINTETICO_NOVO_MENU_3200106108,
    periodo: 'Serviços vigentes em algum momento do período',
  },
  {
    id: 'ParticipantesAnalitico',
    texto: 'Analítico — Participantes dos serviços',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PARTICIPANTESANALITICO_NOVO_MENU_3200106109,
    periodo: 'Vínculos vigentes em algum momento do período',
  },
  {
    id: 'ParticipantesSintetico',
    texto: 'Sintético — Participantes dos serviços',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PARTICIPANTESSINTETICO_NOVO_MENU_3200106110,
    periodo: 'Vínculos vigentes em algum momento do período',
  },
  {
    id: 'GruposAnalitico',
    texto: 'Analítico — Grupos de atendimento',
    permissao: eTipoPermissao.ATENDIMENTO_REL_GRUPOSANALITICO_NOVO_MENU_3200106111,
    periodo: 'Grupos do contrato; participantes da escola no período',
  },
  {
    id: 'GruposSintetico',
    texto: 'Sintético — Grupos de atendimento',
    permissao: eTipoPermissao.ATENDIMENTO_REL_GRUPOSSINTETICO_NOVO_MENU_3200106112,
    periodo: 'Grupos do contrato; participantes da escola no período',
  },
  {
    id: 'Agenda',
    texto: 'Analítico — Minha agenda',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AGENDA_NOVO_MENU_3200106113,
    complementar: eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400,
    periodo: 'Data do agendamento; somente terapeuta logado',
  },
  {
    id: 'AgendaSintetico',
    texto: 'Sintético — Minha agenda',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AGENDASINTETICO_NOVO_MENU_3200106114,
    complementar: eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400,
    periodo: 'Data do agendamento; somente terapeuta logado',
  },
  {
    id: 'FrequenciaAnalitico',
    texto: 'Analítico — Frequência dos meus atendimentos',
    permissao: eTipoPermissao.ATENDIMENTO_REL_FREQUENCIAANALITICO_NOVO_MENU_3200106115,
    complementar: eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400,
    periodo: 'Atendimentos realizados; somente terapeuta logado',
  },
  {
    id: 'FrequenciaSintetico',
    texto: 'Sintético — Frequência dos meus atendimentos',
    permissao: eTipoPermissao.ATENDIMENTO_REL_FREQUENCIASINTETICO_NOVO_MENU_3200106116,
    complementar: eTipoPermissao.ATENDIMENTO_AGENDA_NOVO_MENU_3200100400,
    periodo: 'Atendimentos realizados; somente terapeuta logado',
  },
  {
    id: 'EsperaAnalitico',
    texto: 'Analítico — Espera acima do limite',
    permissao: eTipoPermissao.ATENDIMENTO_REL_ESPERAANALITICO_NOVO_MENU_3200106117,
    periodo: 'Data da solicitação; pendentes com limite de espera atingido',
  },
  {
    id: 'EsperaSintetico',
    texto: 'Sintético — Espera acima do limite',
    permissao: eTipoPermissao.ATENDIMENTO_REL_ESPERASINTETICO_NOVO_MENU_3200106118,
    periodo: 'Data da solicitação; dias e excesso médios',
  },
  {
    id: 'FaltasAnalitico',
    texto: 'Analítico — Faltas acima do limite',
    permissao: eTipoPermissao.ATENDIMENTO_REL_FALTASANALITICO_NOVO_MENU_3200106119,
    periodo: 'Faltas no período e dentro do intervalo configurado',
  },
  {
    id: 'FaltasSintetico',
    texto: 'Sintético — Faltas acima do limite',
    permissao: eTipoPermissao.ATENDIMENTO_REL_FALTASSINTETICO_NOVO_MENU_3200106120,
    periodo: 'Faltas no período e dentro do intervalo configurado',
  },
  {
    id: 'Prontuario',
    texto: 'Analítico — Prontuário do meu paciente',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PRONTUARIO_NOVO_MENU_3200106121,
    complementar: eTipoPermissao.ATENDIMENTO_PRONTUARIO_NOVO_MENU_3200100500,
    periodo: 'Data do atendimento; paciente e atendente vinculados',
  },
  {
    id: 'ProntuarioSintetico',
    texto: 'Sintético — Meus prontuários por paciente',
    permissao: eTipoPermissao.ATENDIMENTO_REL_PRONTUARIOSINTETICO_NOVO_MENU_3200106122,
    complementar: eTipoPermissao.ATENDIMENTO_PRONTUARIO_NOVO_MENU_3200100500,
    periodo: 'Data do atendimento; atendente logado, sem conteúdo clínico',
  },
  {
    id: 'AvisosSecretariaAnalitico',
    texto: 'Analítico — Avisos à secretaria',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AVISOSSECRETARIAANALITICO_NOVO_MENU_3200106123,
    complementar: eTipoPermissao.ATENDIMENTO_AVISOS_SECRETARIA_NOVO_MENU_3200100710,
    periodo: 'Data de criação do aviso; sem alterar leitura',
  },
  {
    id: 'AvisosSecretariaSintetico',
    texto: 'Sintético — Avisos à secretaria',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AVISOSSECRETARIASINTETICO_NOVO_MENU_3200106124,
    complementar: eTipoPermissao.ATENDIMENTO_AVISOS_SECRETARIA_NOVO_MENU_3200100710,
    periodo: 'Data de criação do aviso; sem alterar leitura',
  },
  {
    id: 'AvisosApoioAnalitico',
    texto: 'Analítico — Avisos à equipe de apoio',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AVISOSAPOIOANALITICO_NOVO_MENU_3200106125,
    complementar: eTipoPermissao.ATENDIMENTO_AVISOS_APOIO_NOVO_MENU_3200100720,
    periodo: 'Data de criação do aviso; sem alterar leitura',
  },
  {
    id: 'AvisosApoioSintetico',
    texto: 'Sintético — Avisos à equipe de apoio',
    permissao: eTipoPermissao.ATENDIMENTO_REL_AVISOSAPOIOSINTETICO_NOVO_MENU_3200106126,
    complementar: eTipoPermissao.ATENDIMENTO_AVISOS_APOIO_NOVO_MENU_3200100720,
    periodo: 'Data de criação do aviso; sem alterar leitura',
  },
  {
    id: 'CatalogosAnalitico',
    texto: 'Analítico — Cadastros do módulo',
    permissao: eTipoPermissao.ATENDIMENTO_REL_CATALOGOSANALITICO_NOVO_MENU_3200106127,
    periodo: 'Data de alteração; cadastros comuns ao contrato',
  },
  {
    id: 'CatalogosSintetico',
    texto: 'Sintético — Cadastros do módulo',
    permissao: eTipoPermissao.ATENDIMENTO_REL_CATALOGOSSINTETICO_NOVO_MENU_3200106128,
    periodo: 'Data de alteração; cadastros comuns ao contrato',
  },
  {
    id: 'TerapeutasAnalitico',
    texto: 'Analítico — Terapeutas e volume de agenda',
    permissao: eTipoPermissao.ATENDIMENTO_REL_TERAPEUTASANALITICO_NOVO_MENU_3200106129,
    periodo: 'Terapeutas do contrato; agenda da escola no período',
  },
  {
    id: 'TerapeutasSintetico',
    texto: 'Sintético — Terapeutas e volume de agenda',
    permissao: eTipoPermissao.ATENDIMENTO_REL_TERAPEUTASSINTETICO_NOVO_MENU_3200106130,
    periodo: 'Terapeutas do contrato; agenda da escola no período',
  },
  {
    id: 'Comprovante',
    texto: 'Comprovante de solicitação',
    permissao: eTipoPermissao.ATENDIMENTO_REL_COMPROVANTE_NOVO_MENU_3200106131,
    periodo: 'Solicitação selecionada ou solicitações do período',
  },
  {
    id: 'Desistencia',
    texto: 'Termo de desistência',
    permissao: eTipoPermissao.ATENDIMENTO_REL_DESISTENCIA_NOVO_MENU_3200106132,
    periodo: 'Serviço selecionado ou desistências do período',
  },
];
